import React, { useState, useEffect } from 'react';
import { Spinner, Row, Col, Accordion, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../config/abilityContext';
import { LinkBtn, Icon } from '../../components';
import { showSurveyRequest } from '../../requests/surveys';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import SurveyPreview from './SurveyPreview';
import basicSurvey from './survey';
import EmployeeSurveyDataTable from './EmployeeSurveyDataTable';
import SurveyResults from './SurveyResults';
import columns from './employeeSurveyColumns';

const SurveyShow = ({ match, location }) => {
  const ability = useAbility(AbilityContext);
  const { id } = match.params;
  const history = useHistory();
  const [onRequest, setOnRequest] = useState(true);
  const [survey, setSurvey] = useState(basicSurvey);
  const searchParams = new URLSearchParams(location.search);
  const accordionParam = searchParams.get('accordion');
  const [activeAccordion, setActiveAccordion] = useState(accordionParam || 'results');

  const handleAccordionSelect = k => {
    setActiveAccordion(k);
    const params = new URLSearchParams(location.search);
    if (k) {
      params.set('accordion', k);
      history.replace(`${location.pathname}?${params.toString()}`);
    } else {
      params.delete('accordion');
      const searchStr = params.toString();
      history.replace(searchStr ? `${location.pathname}?${searchStr}` : location.pathname);
    }
  };

  const dispatch = useDispatch();

  const successCallback = response => {
    const parsedSurvey = camelCaseEmptyStringRecursive(response.data);
    setSurvey(parsedSurvey);
  };

  const handleShowRequest = () => {
    setOnRequest(true);
    showSurveyRequest(id, {
      dispatch,
      successCallback,
      callback: () => setOnRequest(false)
    });
  };

  useEffect(handleShowRequest, [id, dispatch]);

  return (
    <div className={`${onRequest && 'bg-opacity'} form-course`}>
      {onRequest && (
        <div className="containerSpinnerLoad fix-middle center-spinner position-fixed">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      <Row className="m-top mb-3 align-items-center">
        <LinkBtn variant="circle-dark" className="btn-circle mt-3" to="/surveys">
          <Icon icon="chevron-back" />
        </LinkBtn>
        <h2 className="text-uppercase ml-4 mt-4">{survey.name}</h2>
      </Row>

      {survey.id && (
        <div className="yellow-wrapper">
          <Accordion activeKey={activeAccordion} onSelect={handleAccordionSelect}>
            <Col className={`${activeAccordion === 'survey' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
              <Accordion.Toggle
                as={Col}
                eventKey="survey"
                className="card-header-title"
                onClick={() => handleAccordionSelect(activeAccordion === 'survey' ? null : 'survey')}
                style={{ cursor: 'pointer' }}
              >
                <span>{survey.name}</span>
              </Accordion.Toggle>
            </Col>

            <Accordion.Collapse eventKey="survey">
              <Card className="border-0">
                <Card.Body className="p-0 border-0">
                  <SurveyPreview
                    survey={survey}
                    employeeSurvey={{ employeeQuestionChoicesAttributes: [] }}
                    hideHeader
                  />
                </Card.Body>
              </Card>
            </Accordion.Collapse>
          </Accordion>

          {ability.can('index', 'EmployeeSurvey') && (
            <Accordion className="my-2" activeKey={activeAccordion} onSelect={handleAccordionSelect}>
              <Col
                className={`${activeAccordion === 'participants' ? 'top-header-green' : 'top-header-light-gray'} br-5`}
              >
                <Accordion.Toggle
                  as={Col}
                  eventKey="participants"
                  className="card-header-title d-flex justify-content-between align-items-center"
                  onClick={() => handleAccordionSelect(activeAccordion === 'participants' ? null : 'participants')}
                  style={{ cursor: 'pointer' }}
                >
                  <span>Participantes</span>
                </Accordion.Toggle>
              </Col>

              <Accordion.Collapse eventKey="participants">
                <Card>
                  <Card.Body className="p-0">
                    <div className="data-table-yellow px-2">
                      <EmployeeSurveyDataTable
                        survey={survey}
                        surveyId={id}
                        rrhh
                        columns={columns}
                        customParams={{ survey_id: id }}
                        hideAddParticipants={searchParams.get('mode') !== 'edit'}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Accordion.Collapse>
            </Accordion>
          )}

          {searchParams.get('mode') !== 'edit' && (
            <Accordion className="my-2" activeKey={activeAccordion} onSelect={handleAccordionSelect}>
              <Col className={`${activeAccordion === 'results' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
                <Accordion.Toggle
                  as={Col}
                  eventKey="results"
                  className="card-header-title"
                  onClick={() => handleAccordionSelect(activeAccordion === 'results' ? null : 'results')}
                  style={{ cursor: 'pointer' }}
                >
                  <span>Resultados</span>
                </Accordion.Toggle>
              </Col>

              <Accordion.Collapse eventKey="results">
                <Card>
                  <Card.Body>
                    <SurveyResults survey={survey} setOnRequest={setOnRequest} onRequest={onRequest} />
                  </Card.Body>
                </Card>
              </Accordion.Collapse>
            </Accordion>
          )}
        </div>
      )}
    </div>
  );
};

export default SurveyShow;
